// extracted by mini-css-extract-plugin
module.exports = {"checkCard":"CheckBoxCardV2_checkCard__16reK","children":"CheckBoxCardV2_children__zTwPK","bgCheckboxCardGreen":"CheckBoxCardV2_bgCheckboxCardGreen__2UEdr"};